import { useState } from 'react';

// auto-take RTK receiver position for drawn points (default on)
const K = 'giss_rtk_auto';
export const rtkAuto = () => localStorage.getItem(K) !== '0';

export function RtkAutoToggle({ t, testid }) {
  const [on, setOn] = useState(rtkAuto);
  const flip = () => { localStorage.setItem(K, on ? '0' : '1'); setOn(!on); };
  return <label className="vs-toggle"><input type="checkbox" data-testid={testid} checked={on} onChange={flip} /><span><b>{t.rtkAuto}</b><br /><small className="muted">{t.rtkAutoD}</small></span></label>;
}
